import React from 'react';
import PropTypes from 'prop-types';

const Pan360 = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.7556 7.82812H6.89395C6.2174 7.82812 5.66895 8.37658 5.66895 9.05313V9.06479C5.66895 9.74134 6.2174 10.2898 6.89395 10.2898H10.7556C11.4322 10.2898 11.9806 9.74134 11.9806 9.06479V9.05313C11.9806 8.37658 11.4322 7.82812 10.7556 7.82812Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M10.7556 13.125H6.89395C6.2174 13.125 5.66895 13.6735 5.66895 14.35V14.3617C5.66895 15.0382 6.2174 15.5867 6.89395 15.5867H10.7556C11.4322 15.5867 11.9806 15.0382 11.9806 14.3617V14.35C11.9806 13.6735 11.4322 13.125 10.7556 13.125Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M15.9126 9.49596C15.9309 9.91146 16.0708 10.3124 16.3149 10.6491C16.5591 10.9858 16.8967 11.2434 17.286 11.3899C17.6752 11.5364 18.0989 11.5653 18.5045 11.4732C18.91 11.381 19.2796 11.1718 19.5673 10.8714C19.8549 10.5711 20.0481 10.1929 20.1228 9.78374C20.1974 9.3746 20.1503 8.95255 19.9872 8.56997C19.8241 8.18739 19.5522 7.86112 19.2053 7.63168C18.8585 7.40223 18.4518 7.2797 18.036 7.2793C17.751 7.28536 17.47 7.34751 17.209 7.4622C16.948 7.5769 16.7122 7.74188 16.5151 7.94773C16.3179 8.15358 16.1632 8.39626 16.0598 8.66191C15.9564 8.92756 15.9064 9.21098 15.9126 9.49596Z"
      fill={fill || '#6B6C7B'}
    />
    <g clipPath="url(#clip0_5626_41764)">
      <path
        d="M19.8906 20.5327C19.8922 20.9924 19.9498 21.4502 20.0621 21.896H21.8541V19.2744H20.0372C19.9416 19.6871 19.8924 20.1091 19.8906 20.5327Z"
        fill={fill || '#6B6C7B'}
      />
      <path
        d="M22.3242 19.2744V21.896H24.1162C24.2332 21.4508 24.2954 20.993 24.3015 20.5327C24.3006 20.1092 24.2524 19.6872 24.1577 19.2744H22.3242Z"
        fill={fill || '#6B6C7B'}
      />
      <path
        d="M22.0888 16.1084C21.2136 16.1084 20.3582 16.3679 19.6305 16.8541C18.9029 17.3403 18.3358 18.0313 18.0009 18.8398C17.666 19.6483 17.5784 20.538 17.7491 21.3963C17.9198 22.2546 18.3412 23.043 18.96 23.6618C19.5788 24.2806 20.3672 24.702 21.2255 24.8728C22.0838 25.0435 22.9735 24.9559 23.782 24.621C24.5905 24.2861 25.2816 23.719 25.7678 22.9913C26.2539 22.2637 26.5134 21.4082 26.5134 20.5331C26.5134 19.3596 26.0473 18.2342 25.2175 17.4044C24.3877 16.5746 23.2623 16.1084 22.0888 16.1084ZM25.4681 22.3887H24.467C24.2777 22.9813 23.9979 23.541 23.6374 24.048C23.3714 24.1639 23.0931 24.2492 22.8078 24.3024C23.3187 23.7472 23.7119 23.0944 23.9637 22.3832H22.3266V24.3604H21.8592V22.3887H20.2138C20.4653 23.1009 20.8585 23.7547 21.3697 24.3107C21.0903 24.2581 20.8176 24.1746 20.5567 24.0618C20.1949 23.5506 19.915 22.9861 19.7271 22.3887H18.7094C18.6211 22.2275 18.5443 22.0603 18.4799 21.8882H19.586C19.4824 21.4438 19.4286 20.9893 19.4256 20.5331C19.4258 20.1102 19.4703 19.6885 19.5584 19.2748H18.4273C18.4855 19.1032 18.5557 18.936 18.6375 18.7743H19.6911C19.8888 18.1158 20.1954 17.4952 20.5982 16.938C20.8536 16.8322 21.1197 16.7543 21.3919 16.7057C20.8417 17.2962 20.4265 17.9992 20.1751 18.766H21.8592V16.6615H22.3266V18.7743H24.0107C23.7597 18.0087 23.3455 17.3067 22.7967 16.7168C23.0684 16.7619 23.3345 16.836 23.5904 16.938C23.9908 17.4911 24.2964 18.107 24.4947 18.7604H25.5373C25.619 18.9221 25.6893 19.0894 25.7474 19.261H24.6247C24.7147 19.679 24.7601 20.1055 24.7602 20.5331C24.7587 20.992 24.7059 21.4493 24.6025 21.8964H25.7087C25.6403 22.066 25.5599 22.2305 25.4681 22.3887Z"
        fill={fill || '#6B6C7B'}
      />
    </g>
    <path
      d="M16.3332 15.0973L20.1599 13.3939L20.5099 13.2773C19.7045 12.9725 18.851 12.8144 17.9899 12.8106C16.971 12.8071 15.9637 13.0261 15.0382 13.4523C14.6457 13.6289 14.3131 13.9161 14.0811 14.2787C13.849 14.6412 13.7276 15.0635 13.7315 15.4939C13.7315 16.0773 13.7315 16.1239 14.3032 16.1356H15.2365C15.4769 15.6775 15.8627 15.3122 16.3332 15.0973Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M14.9687 19.8336V19.1919H3.8504V4.66689H24.1504V14.3036L25.9587 15.1086C26.2352 15.2397 26.4846 15.4218 26.6937 15.6452V4.66689C26.7063 3.97883 26.4457 3.31385 25.969 2.8175C25.4923 2.32115 24.8384 2.03387 24.1504 2.01855H3.8504C3.16241 2.03387 2.5085 2.32115 2.03183 2.8175C1.55516 3.31385 1.29456 3.97883 1.30707 4.66689V19.1802C1.29767 19.8663 1.55966 20.5283 2.03599 21.0221C2.51233 21.5159 3.16446 21.8016 3.8504 21.8169H15.2604C15.0756 21.1717 14.9775 20.5047 14.9687 19.8336Z"
      fill={fill || '#6B6C7B'}
    />
    <defs>
      <clipPath id="clip0_5626_41764">
        <rect
          width="9.95556"
          height="9.95556"
          fill="white"
          transform="translate(17.1113 15.5557)"
        />
      </clipPath>
    </defs>
  </svg>
);

Pan360.propTypes = {
  fill: PropTypes.string,
};

export default Pan360;
